import { promptVars } from '../variables';
import { schemaBasePrompt } from './schemaBasePrompt';
export const schemaUpdatePrompt = schemaBasePrompt
    .temp(1)
    .model('us.anthropic.claude-3-5-sonnet-20240620-v1:0')
    .human(`
# Current model:
${promptVars.modelStmts}

# User input
${promptVars.userInput}

Return only DSL that is needed to update defined model. DO NOT include anything else.
`);
//# sourceMappingURL=schemaUpdatePrompt.js.map